import {useLocation} from 'react-router';
import {Link} from './ScopedLink';
import {safeWorkflowReturn} from './WorkflowReturn';

/** F#46 first cut: an onboarding task opens the real building record with a safe returnTo; this links back to that onboarding step. */
export function OnboardingReturnLink({building}:{building:string}){
  const location=useLocation(),returnTo=safeWorkflowReturn(new URLSearchParams(location.search).get('returnTo'));
  if(!returnTo||new URL(returnTo,'https://staff.invalid').pathname!==`/buildings/${building}/onboarding`)return null;
  return <p><Link to={returnTo}>Return to onboarding</Link></p>;
}
